<template>

  <div v-if="isDataLoading" class="row">
    <div class="col">
      <vue-loaders name="ball-beat"></vue-loaders>
    </div>
  </div>
  <div v-else>
    <div v-for="(audit, index) in auditsDataAfficher" v-bind:key="audit.cle" class="row ligne-audit-changement">
      <div class="col text-left">
        <div v-if="index === 0" class="row large-600 bold">Enregistrement courant</div>
        <div v-if="audit.dateChangement" class="row large-600 bold">Informations enregistrées le : {{
            $commun.formatDateHeure(audit.dateChangement)
          }}
        </div>      
        <div v-else class="row large-600 bold">Informations enregistrées le : {{
            $commun.formatDateHeure(dossier.creerLe)
          }}
        </div>
        <div v-if="audit.changeParEntite" class="row large-600 bold">
          Par : {{ audit.changeParEntite.nomIntervenant?.trim() }}, {{ audit.changeParEntite.prenomIntervenant?.trim() }},
          {{ audit.changeParEntite.nomGroupeSecurite?.trim() }}
        </div>
        <div v-else class="row large-600 erreur bold">
          Intervenant(e) inconnu(e)...
        </div>

        <div v-for="field in AUDIT_FIELDS" v-bind:key="field" class="row">
          <div class="col-5">{{ FIELD_LABELS[field] }} :</div>
          <div class="col text-center">
            <div v-if="audit[field].isModifie">{{ this.MODIFIED_ARROW }}</div>
          </div>
          <div class="col">{{ audit[field].texte }}</div>
        </div>
      </div>
    </div>

    <h3>Nombre de modifications : {{ nombreModifications }}</h3>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from "vuex";

export default {
  name: "DossierTableModifications",
  emits: ["isDataLoaded", "backendError"],
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.isDataLoading = true;
    this.$store
        .dispatch("dossier/obtenirAuditsAction", {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
        })
        .then((res) => {
          this.auditsData = res.data.entite.audits
          if (res.data.entite.audits !== null && res.data.entite.audits.length > 0) {
            this.auditsDataAfficher = this.formatterAudits(res.data.entite.audits)
          } else {
            this.auditsDataAfficher = this.formatterAucunAudit();
          }
          this.isDataLoading = false;
        })
        .catch((err) => {
          this.$emit("backendError", err);
        })
        .finally(() => {
          this.$emit("isDataLoaded", true);
        })
  },
  data() {
    return {
      isDataLoading: false,
      auditsData: [],
      auditsDataAfficher: [],
      MODIFIED_ARROW: "🢂",
      //FIXME: ajouter les champs à afficher, leur labels
      AUDIT_FIELDS: [
        "numeroCardexAfficher",
        "siteAfficher",
        "genreAfficher",
        "natureAfficher",
        "typeAfficher",
        "categorieAfficher",
        "numeroDossier",
        "statutAfficher",
        "fondeAfficher",
        "severiteAfficher",
        "confidentialiteAfficher",
        "descriptif",
        "debutDate",
        "finDate",
        "reference1",
        "reference2",
        "reference3",
        "enregistrementNumerique",
        "sequentielNumero",
        "conserverEnregistrement",
        "origineAfficher",
        "endroitAfficher",
        "localisationAfficher",
        "intervenantAfficher"
      ],
      FIELD_LABELS: {
        "numeroCardexAfficher": "No Cardex",
        "siteAfficher": "Site d'origine",
        "genreAfficher": "Genre",
        "natureAfficher": "Nature",
        "typeAfficher": "Type",
        "categorieAfficher": "Catégorie",
        "numeroDossier": "No de dossier",
        "statutAfficher": "Statut",
        "fondeAfficher": "Fondé",
        "severiteAfficher": "Sévérité",
        "confidentialiteAfficher": "Confidentialité",
        "descriptif": "Descriptif",
        "debutDate": "Survenu le",
        "finDate": "Date de fin",
        "reference1": "Référence 1",
        "reference2": "Référence 2",
        "reference3": "Référence 3",
        "enregistrementNumerique": "Enregistrement",
        "sequentielNumero": "Numéro séquentiel",
        "conserverEnregistrement": "Enregistrement",
        "origineAfficher": "Origine",
        "endroitAfficher": "Endroit",
        "localisationAfficher": "Localisation",
        "intervenantAfficher": "Intervenant principal"
      },
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
      dossier: "dossier/dossier",
    }),
    nombreModifications() {
      if(this.auditsData.length > 0){
        return this.auditsData.length - 1;
      }else{
        return this.auditsData.length;
      }
    },
    createur() {
      return this.dossier.creerParDescription
    },
    dateCreation() {
      return this.dossier.creerLe
    },
  },
  methods: {
    formatterAudits(listeAudits) {
      let listeAffichage = []
      let auditPrecedent = null

      // pour bâtir la diff, il faut revenir en arrière en commençant par
      // l'enregistrement le plus vieux
      listeAudits.sort((a, b) => {
        return new Date(a.dateChangement) - new Date(b.dateChangement)
      });

      // par design, on veut afficher les info actuelles dans le dernier enregistrement.
      // on pousse donc artificiellement un "audit" avec les infos actuelles du dossier
      listeAudits.push({
        "numeroCardexAfficher": this.dossier.numeroCardexAfficher,
        "siteAfficher": this.dossier.siteAfficher,
        "genreAfficher": this.dossier.genreAfficher,
        "natureAfficher": this.dossier.natureAfficher,
        "typeAfficher": this.dossier.typeAfficher,
        "categorieAfficher": this.dossier.categorieAfficher,
        "numeroDossier": this.dossier.numeroDossier,
        "statutAfficher": this.dossier.statutAfficher,
        "fondeAfficher": this.dossier.fondeAfficher,
        "severiteAfficher": this.dossier.severiteAfficher,
        "confidentialiteAfficher": this.dossier.confidentialiteAfficher,
        "descriptif": this.dossier.descriptif,
        "debutDate": this.dossier.debutDate,
        "finDate": this.dossier.finDate,
        "reference1": this.dossier.reference1,
        "reference2": this.dossier.reference2,
        "reference3": this.dossier.reference3,
        "enregistrementNumerique": this.dossier.enregistrementNumerique,
        "sequentielNumero": this.dossier.sequentielNumero,
        "conserverEnregistrement": this.dossier.conserverEnregistrement,
        "origineAfficher": this.dossier.origineAfficher,
        "endroitAfficher": this.dossier.endroitAfficher,
        "localisationAfficher": this.dossier.localisationAfficher,
        "intervenantAfficher": this.dossier.intervenantAfficher,
        "changeParEntite": this.dossier.changeParEntite,
      }),

          listeAudits.forEach((audit, index) => {
            let auditAffichage = {}
            this.AUDIT_FIELDS.forEach(field => {
              auditAffichage[field] = {texte: audit[field], isModifie: false,}
              if (auditPrecedent
                  && auditPrecedent[field].texte !== auditAffichage[field].texte) {
                auditAffichage[field].isModifie = true
              }
            })

            // pour l'affichage, il faut comprendre que les entrées de la table
            // d'audits sauvegardent l'information du dossier _avant_ qu'il ne change.
            // autrement dit, puisqu'on commence avec creerParEntite, les informations suivantes
            // du dossier sont une date "en retard".
            auditAffichage.changeParEntite = index === 0
                ? this.dossier.creerParEntite
                : listeAudits[index - 1].changeParEntite

            auditAffichage.dateChangement = index === 0
                ? this.dossier.creerLe
                : listeAudits[index - 1].dateChangement

            auditPrecedent = auditAffichage

            listeAffichage.push(auditAffichage)
          })

      // par design, la liste est affichée à partir du plus récent enregistrement.
      // pour ne pas désordonner la liste finale, dans le cas vraiment weird où la
      // date de création serait plus avancée que la date du premier audit (e.g. immatriculation MMK9098),
      // on shift() le premier élément avant de filter, puis on le repousse à la fin
      let tmpAuditCreationDossier = listeAffichage.shift()
      listeAffichage.sort((a, b) => {
        return new Date(b.dateChangement) - new Date(a.dateChangement)
      });
      listeAffichage.push(tmpAuditCreationDossier)

      return listeAffichage
    },
    formatterAucunAudit() {
      let listeAudits = [];
      let audit = {
        "numeroCardexAfficher": this.dossier.numeroCardexAfficher,
        "siteAfficher": this.dossier.siteAfficher,
        "genreAfficher": this.dossier.genreAfficher,
        "natureAfficher": this.dossier.natureAfficher,
        "typeAfficher": this.dossier.typeAfficher,
        "categorieAfficher": this.dossier.categorieAfficher,
        "numeroDossier": this.dossier.numeroDossier,
        "statutAfficher": this.dossier.statutAfficher,
        "fondeAfficher": this.dossier.fondeAfficher,
        "severiteAfficher": this.dossier.severiteAfficher,
        "confidentialiteAfficher": this.dossier.confidentialiteAfficher,
        "descriptif": this.dossier.descriptif,
        "debutDate": this.dossier.debutDate,
        "finDate": this.dossier.finDate,
        "reference1": this.dossier.reference1,
        "reference2": this.dossier.reference2,
        "reference3": this.dossier.reference3,
        "enregistrementNumerique": this.dossier.enregistrementNumerique,
        "sequentielNumero": this.dossier.sequentielNumero,
        "conserverEnregistrement": this.dossier.conserverEnregistrement,
        "origineAfficher": this.dossier.origineAfficher,
        "endroitAfficher": this.dossier.endroitAfficher,
        "localisationAfficher": this.dossier.localisationAfficher,
        "intervenantAfficher": this.dossier.intervenantAfficher,
        "changeParEntite": this.dossier.creerParEntite
      }
      let auditAffichage = {}
      this.AUDIT_FIELDS.forEach(field => {
        auditAffichage[field] = {texte: audit[field], isModifie: false,}
      })

      auditAffichage.changeParEntite = audit.changeParEntite

      listeAudits.push(auditAffichage);
      return listeAudits;
    }
  },
};
</script>